export const SECTION_PATHS = {
  about: 'about',
  ourSolutions: 'ourSolutions',
  technology: 'technology',
  cases: 'cases',
  team: 'team',
  contact: 'contact',
};
